import dayjs from 'dayjs';

// The PDP details rows show only the year.
export const getDisplayYear = (value: string | null | undefined) => {
	const date = value ? dayjs(value) : null;
	return date?.isValid() ? String(date.year()) : undefined;
};
